import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    TWITTER,
    YOUTUBE
} from '@/lib/socialProfile';

export const IG_POST_ICONS = {
    photo: 'content',
    video: 'video',
    carousel: 'carousel',
    reel: 'reel'
} as const;

export const IG_STORY_ICONS = {
    photo: 'content',
    video: 'video'
} as const;

export const TI_POST_ICONS = {
    video: 'video'
} as const;

export const FB_POST_ICONS = {
    photo: 'content',
    video: 'video',
    carousel: 'carousel',
    story: 'link',
    mobile_status: 'text',
    reel: 'reel'
} as const;

export const TW_POST_ICONS = {
    status: 'text',
    photo: 'content',
    video: 'video',
    carousel: 'carousel',
    retweet: 'retweet',
    retweet_comment: 'quotes',
    quote: 'quotes',
    link: 'link',
    reply: 'reply',
    poll: 'poll'
} as const;

export const LI_POST_ICONS = {
    photo: 'content',
    video: 'video',
    carousel: 'carousel',
    status: 'text',
    link: 'link',
    document: 'doc',
    poll: 'poll'
} as const;

export const YT_POST_ICONS = {
    video: 'video',
    short: 'story'
} as const;

export const PI_POST_ICONS = {
    image: 'content',
    multiple_images: 'carousel-images',
    multiple_mixed: 'carousel',
    multiple_videos: 'carousel-videos',
    video: 'video'
} as const;

export const NetworkPostIcons = {
    [INSTAGRAM]: IG_POST_ICONS,
    [FACEBOOK]: FB_POST_ICONS,
    [LINKEDIN]: LI_POST_ICONS,
    [PINTEREST]: PI_POST_ICONS,
    [TIKTOK_BUSINESS]: TI_POST_ICONS,
    [TWITTER]: TW_POST_ICONS,
    [YOUTUBE]: YT_POST_ICONS
} as const;
